import { isNil, isUndefined } from 'lodash';
import { injectIntl } from 'react-intl';
import { get } from 'immutable';

export default function withPlaceholder(ComponentToWrap) {
  const getPlaceholder = (props) => {
    const { intl, placeholder } = props;

    if (typeof placeholder === 'string') {
      return placeholder;
    }

    if (!isNil(placeholder)) {
      return intl.formatMessage({
        id: get(placeholder, 'translationId'),
      });
    }

    return placeholder;
  };

  return injectIntl((props) => {
    let { value } = props;

    // @ts-expect-error TS(2322): Type '"" | IntlShape' is not assignable to type 'I... Remove this comment to see the full error message
    value = isUndefined(value) ? '' : value;

    return <ComponentToWrap {...props} value={value} placeholder={getPlaceholder(props)} />;
  });
}
